<template>
  <div>

    <div class="row" v-if="userData.permissions['view_financial_years'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-financial-year size="sm" variant="primary"><i class="mdi mdi-plus"></i> New
                Financial
                Year</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">
                <template #table-busy>
                  <div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow"
                      small></b-spinner> <strong>No Data Found</strong></div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(start)="data">
                  {{ formatDate(data.item.start) }}
                </template>

                <template #cell(end)="data">
                  {{ formatDate(data.item.end) }}
                </template>

                <template #cell(active)="data">
                  <span v-if="data.item.active == 1">
                    <b-button type="button" class="btn-sm btn" variant="info" v-b-modal.password> <i
                        class="mdi mdi-check"></i> Active </b-button>
                  </span>
                  <span v-else>
                    <b-button @click="makedefault(data.item.id, data.item.name)" type="button" class="btn-sm btn"
                      variant="secondary" v-b-modal.password> <i class="mdi mdi-lock"></i> Set as Active</b-button>
                  </span>
                </template>

                <template #cell(actions)="data">
                  <b-button type="button" class="btn-sm btn" variant="outline-primary"
                    @click="adjustOptionModal(data.item.id, data.item.start, data.item.end)">
                    <i class="mdi mdi-pencil"></i> Adjust
                  </b-button>
                </template>

              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to view Financial Years</span></center>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="new-financial-year" centered title="New Financial Year" title-class="font-18" hide-footer
      @show="resetCreateErrors">
      <form @submit.prevent="addOption">
        <div v-if="createErrors.length" class="alert alert-danger mb-2" role="alert">
          <div>Please fix the following before submitting:</div>
          <ul class="mb-0 ps-3">
            <li v-for="(error, idx) in createErrors" :key="idx">{{ error }}</li>
          </ul>
        </div>
        <div class="form-group mb-2">
          <label>Start</label>
          <input v-model="start" type="month" class="form-control" :class="{ 'is-invalid': fieldErrors.start }" />
          <small v-if="fieldErrors.start" class="invalid-feedback d-block">{{ fieldErrors.start }}</small>
        </div>
        <div class="form-group mb-2">
          <label>End</label>
          <input v-model="end" type="month" class="form-control" :class="{ 'is-invalid': fieldErrors.end }" />
          <small v-if="fieldErrors.end" class="invalid-feedback d-block">{{ fieldErrors.end }}</small>
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('new-financial-year')">Cancel</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary" :disabled="isSubmittingCreate"><i
              class="fas fa-check-circle"></i>
            Submit</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="adjust-financial-year" centered title="Adjust Financial Year" title-class="font-18" hide-footer
      @show="resetCreateErrors">

      <div class="alert alert-info py-2 mb-3">
        <span class="small text-uppercase fw-bold text-muted d-block mb-1">Current Range</span>
        <span class="fs-6">{{ formatDate(currentStart) }} &mdash; {{ formatDate(currentEnd) }}</span>
      </div>

      <form @submit.prevent="adjustOption">
        <div v-if="createErrors.length" class="alert alert-danger mb-2" role="alert">
          <div>Please fix the following before submitting:</div>
          <ul class="mb-0 ps-3">
            <li v-for="(error, idx) in createErrors" :key="idx">{{ error }}</li>
          </ul>
        </div>
        <div class="form-group mb-2">
          <label>Start</label>
          <input v-model="start" type="month" class="form-control" :class="{ 'is-invalid': fieldErrors.start }" />
          <small v-if="fieldErrors.start" class="invalid-feedback d-block">{{ fieldErrors.start }}</small>
        </div>
        <div class="form-group mb-2">
          <label>End</label>
          <input v-model="end" type="month" class="form-control" :class="{ 'is-invalid': fieldErrors.end }" />
          <small v-if="fieldErrors.end" class="invalid-feedback d-block">{{ fieldErrors.end }}</small>
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('adjust-financial-year')">Cancel</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary" :disabled="isSubmittingCreate"><i
              class="fas fa-check-circle"></i>
            Submit</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="activate-financial-year" centered title="Set as Active Financial Year" title-class="font-18"
      hide-footer>
      <form @submit.prevent="makeDefualtOption">
        <input v-model="id" type="hidden">
        Are you sure you want to make <b>{{ name }}</b> the active Financial Year
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('activate-financial-year')">Cancel</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            YES</b-button>
        </div>
      </form>
    </b-modal>

  </div>
</template>

<script>
import axios from "axios";
import appConfig from "@/app.config";
import { financialyearMethods, financialyearComputed } from "@/state/helpers";

export default {
  page: {
    title: "Financial Years",
    meta: [{ name: "description", content: appConfig.description, },],
  },

  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Financial Years",
      items: [{ text: "Dashboard", to: "/", }, { text: "Financial Years", active: true, },],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: 'index', label: '#', visible: true },
        { key: 'start', label: 'Start', visible: true },
        { key: 'end', label: 'End', visible: true },
        { key: 'active', label: 'Default', visible: true },
        { key: 'actions', label: 'Actions', visible: true },
      ],
      isSubmittingCreate: false,
      createErrors: [],
      fieldErrors: { start: '', end: '' },
      id: '', name: '', start: '', end: '',
      currentStart: '', currentEnd: ''
    };
  },
  computed: {
    ...financialyearComputed,
    List() { return this.financialyears.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.financialyears.map((d) => ({ ...d })) },
    IsBusy() { let a = false; if (this.financialyears.length > 0) { a = false; } else { a = true; } return a },
  },
  mounted() {
    this.fetchFinancialYears();
    this.TotalRows = this.financialyears.length;
    this.isBusy = false;
  },
  methods: {
    ...financialyearMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    makedefault(id, name) {
      this.id = id;
      this.name = name;
      this.$bvModal.show('activate-financial-year')
    },
    resetCreateErrors() {
      this.createErrors = [];
      this.fieldErrors = { start: '', end: '' };
    },

    adjustOptionModal(id, start, end) {
      this.id = id;

      this.currentStart = start;
      this.currentEnd = end;

      this.start = start ? start.substring(0, 7) : '';
      this.end = end ? end.substring(0, 7) : '';

      this.$bvModal.show('adjust-financial-year');
    },

    validateAdjustRange() {
      this.resetCreateErrors();

      if (!this.start) {
        this.fieldErrors.start = 'Start month is required.';
        this.createErrors.push(this.fieldErrors.start);
      }
      if (!this.end) {
        this.fieldErrors.end = 'End month is required.';
        this.createErrors.push(this.fieldErrors.end);
      }
      if (this.createErrors.length) {
        return false;
      }

      let startIdx = this.monthToIndex(this.start);
      let endIdx = this.monthToIndex(this.end);

      if (endIdx < startIdx) {
        let msg = 'End month cannot be earlier than start month.';
        this.fieldErrors.end = msg;
        this.createErrors.push(msg);
      }

      // Check overlap, but explicitly ignore the current ID being edited
      let overlappingYear = this.financialyears.find((year) => {
        if (!year.start || !year.end || year.id === this.id) {
          return false;
        }
        let existingStart = this.monthToIndex(year.start.slice(0, 7));
        let existingEnd = this.monthToIndex(year.end.slice(0, 7));
        return startIdx <= existingEnd && existingStart <= endIdx;
      });

      if (overlappingYear) {
        this.createErrors.push(
          `Selected range overlaps with existing financial year ${this.monthLabel(overlappingYear.start.slice(0, 7))} to ${this.monthLabel(overlappingYear.end.slice(0, 7))}.`
        );
      }

      return this.createErrors.length === 0;
    },

    async adjustOption() {
      if (!this.validateAdjustRange()) {
        return;
      }

      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("start", this.start);
      formData.append("end", this.end);

      // Update this route to match your actual backend endpoint for updating
      let url = "/adjustfinancialyear";

      try {
        this.isSubmittingCreate = true;
        let response = await axios.post(url, formData);

        if (response.status == 200) {
          this.fetchFinancialYears();
          this.$bvModal.hide('adjust-financial-year');
          this.resetCreateErrors();
          if (this.$toast) {
            this.$toast.success("Financial year adjusted successfully");
          }
        }
      } catch (error) {
        let message = "Failed to adjust financial year. Please check your range and try again.";
        if (error?.response?.data?.message) {
          message = error.response.data.message;
        } else if (error?.response?.data?.error) {
          message = error.response.data.error;
        }
        this.createErrors = [message];
        if (this.$toast) {
          this.$toast.error(message);
        }
      } finally {
        this.isSubmittingCreate = false;
      }
    },

    monthLabel(monthValue) {
      let [year, month] = monthValue.split('-').map(Number);
      let d = new Date(year, month - 1, 1);
      let monthName = d.toLocaleString('default', { month: 'long' });
      return `${monthName} ${year}`;
    },
    monthToIndex(monthValue) {
      let [year, month] = monthValue.split('-').map(Number);
      return (year * 12) + (month - 1);
    },
    validateCreateRange() {
      this.resetCreateErrors();

      if (!this.start) {
        this.fieldErrors.start = 'Start month is required.';
        this.createErrors.push(this.fieldErrors.start);
      }

      if (!this.end) {
        this.fieldErrors.end = 'End month is required.';
        this.createErrors.push(this.fieldErrors.end);
      }

      if (this.createErrors.length) {
        return false;
      }

      let startIdx = this.monthToIndex(this.start);
      let endIdx = this.monthToIndex(this.end);
      let currentDate = new Date();
      let currentMonthIdx = (currentDate.getFullYear() * 12) + currentDate.getMonth();

      if (endIdx < startIdx) {
        let msg = 'End month cannot be earlier than start month.';
        this.fieldErrors.end = msg;
        this.createErrors.push(msg);
      }

      if (startIdx < currentMonthIdx || endIdx < currentMonthIdx) {
        this.createErrors.push('Past ranges are not allowed. Please choose current or future months.');
      }

      let overlappingYear = this.financialyears.find((year) => {
        if (!year.start || !year.end) {
          return false;
        }
        let existingStart = this.monthToIndex(year.start.slice(0, 7));
        let existingEnd = this.monthToIndex(year.end.slice(0, 7));
        return startIdx <= existingEnd && existingStart <= endIdx;
      });

      if (overlappingYear) {
        this.createErrors.push(
          `Selected range overlaps with existing financial year ${this.monthLabel(overlappingYear.start.slice(0, 7))} to ${this.monthLabel(overlappingYear.end.slice(0, 7))}.`
        );
      }

      return this.createErrors.length === 0;
    },
    async addOption() {
      if (!this.validateCreateRange()) {
        return;
      }

      let formData = new FormData();
      formData.append("start", this.start);
      formData.append("end", this.end);
      let url = "/addfinancialyear";

      try {
        this.isSubmittingCreate = true;
        let response = await axios.post(url, formData);
        if (response.status == 200) {
          this.fetchFinancialYears();
          this.$bvModal.hide('new-financial-year');
          this.name = "";
          this.start = "";
          this.end = "";
          this.resetCreateErrors();
          if (this.$toast) {
            this.$toast.success("Financial year created successfully");
          }
        }
      } catch (error) {
        let message = "Failed to create financial year. Please check your range and try again.";

        if (error?.response?.data?.message) {
          message = error.response.data.message;
        } else if (error?.response?.data?.error) {
          message = error.response.data.error;
        }

        this.createErrors = [message];

        if (this.$toast) {
          this.$toast.error(message);
        }
      } finally {
        this.isSubmittingCreate = false;
      }
    },

    formatDate(date) {
      let d = new Date(date);
      let month = d.toLocaleString('default', { month: 'long' });
      let year = d.getFullYear();
      return [month, year].join(' ');
    },

    async makeDefualtOption() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/activefinancialyear";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          localStorage.setItem("financialyear", JSON.stringify(response.data.year));
          this.fetchFinancialYears();
          this.$bvModal.hide('activate-financial-year');
        }
      });
    },
  },
};
</script>